// Types
import { ButtonProps } from '../../types/actions/buttons';

export const validate = ({ id, variant, addGhost }: ButtonProps) => {
  if (!id && variant === 'icon-button') {
    throw new Error(
      "Please ensure an ID has been provided when the variant has been marked as 'icon-button'",
    );
  }

  if (
    addGhost &&
    variant !== 'accent' &&
    variant !== 'primary' &&
    variant !== 'neutral'
  ) {
    throw new Error(
      "The 'addGhost' property should only be used with the 'primary', 'accent' and 'neutral' variants",
    );
  }
};
